import React from 'react';
import styled from 'styled-components';
import {
  boxShadow,
  headingStyles,
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
  visuallyHidden,
} from '../styles';
import { Button, Container, HtmlContent } from './ui';

const StyledArtworkTransferOptions = styled.section`
  ${sectionPaddings()};
  background-color: ${standardColours.lightestGrey};
`;

const StyledHeading = styled.h2`
  ${visuallyHidden()};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

const StyledItem = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  text-align: center;
  background-color: ${standardColours.white};
  ${boxShadow()};

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.medium`
    padding: 50px;
  `}

  ${minBreakpointQuery.large`
    padding: 60px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding: 70px;
  `}

  ${minBreakpointQuery.xxxxlarge`
    padding: 75px;
  `}
`;

const StyledIcon = styled.img`
  margin-bottom: 20px;
  height: 60px;
  width: 70px;
`;

const StyledSubheading = styled.h3`
  ${headingStyles()};
`;

const StyledText = styled(HtmlContent)`
  margin: 20px 0;

  ${minBreakpointQuery.small`
    margin-top: 25px;
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
    margin-bottom: 30px;
  `}
`;

const StyledButton = styled(Button)`
  margin-top: auto;
`;

const ArtworkTransferOptions = ({ heading, items }) => (
  <StyledArtworkTransferOptions>
    <Container>
      <StyledHeading>{heading}</StyledHeading>
      <StyledItems>
        {items.map(({ icon, heading, text, link }, id) => (
          <StyledItem key={id}>
            <StyledIcon src={icon.url} alt={icon.alt} loading="lazy" />
            <StyledSubheading>{heading}</StyledSubheading>
            <StyledText content={text} />
            <StyledButton to={link.pageUrl}>{link.text}</StyledButton>
          </StyledItem>
        ))}
      </StyledItems>
    </Container>
  </StyledArtworkTransferOptions>
);

export default ArtworkTransferOptions;
